import { HewSync } from "./HewSync";
import { DynamoType } from "./DynamoType";

export class BaseType extends DynamoType {
	@HewSync.Field({
		type: "ID"
	})
	public readonly id: HewSync.ID<BaseType>;
}
